import React from "react";

const CardBg = ({ shoeImg }) => {
  return (
    <div className="cardBg">
      <img src={shoeImg} alt="shoe" />
    </div>
  );
};

export default CardBg;
